import { FC } from 'react';
import { useTranslation } from 'hooks';
import { ICONS } from 'shared/constants/images';
import { Card } from 'shared/ui/card/card';
import Drawer from 'shared/ui/drawer/drawer';
import { Icon } from 'shared/ui/icon/icon';
import cls from './whats-included-drawer.module.scss';
import { WhatsIncludedDrawerProps } from 'pages/subscriptions/ui/whats-included-drawer/whats-included-drawer.types';

const WHAT_YOU_GET = [
  {
    icon: ICONS.snapshot,
    titleKey: 'visibilitySnapshot',
    descKey: 'visibilitySnapshotDesc',
  },
  {
    icon: ICONS.benchmark,
    titleKey: 'competitorBenchmarks',
    descKey: 'competitorBenchmarksDesc',
  },
  {
    icon: ICONS.roadmap,
    titleKey: 'improvementRoadmap',
    descKey: 'improvementRoadmapDesc',
  },
] as const;

const WHATS_INCLUDED = [
  { titleKey: 'techAccessibility', descKey: 'techAccessibilityDesc' },
  { titleKey: 'businessInfo', descKey: 'businessInfoDesc' },
  { titleKey: 'productsAndServicesV', descKey: 'productsAndServicesVDesc' },
  { titleKey: 'improvementCenter', descKey: 'improvementCenterDesc' },
  { titleKey: 'progressTracking', descKey: 'progressTrackingDesc' },
] as const;

export const WhatsIncludedDrawer: FC<WhatsIncludedDrawerProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Drawer isOpen={isOpen} onClose={onClose} title={t('rivaLicense')}>
      <div className={cls.drawerContent}>
        <Card className={cls.main}>
          <div className={cls.heading}>
            <h2>{t('whatYouGet')}</h2>
            <p>{t('whatYouGetDesc')}</p>
          </div>
          <div className={cls.whatYouGetGrid}>
            {WHAT_YOU_GET.map(({ icon, titleKey, descKey }) => (
              <div key={titleKey} className={cls.whatYouGetTile}>
                <div className={cls.icon}>
                  <Icon pathToIcon={icon} />
                </div>
                <p>{t(titleKey)}</p>
                <span>{t(descKey)}</span>
              </div>
            ))}
          </div>
        </Card>
        <Card className={cls.main}>
          <div className={cls.heading}>
            <h2>{t('whatsIncluded')}</h2>
          </div>
          <div className={cls.whatsIncluded}>
            {WHATS_INCLUDED.map(({ titleKey, descKey }) => (
              <div key={titleKey}>
                <p>{t(titleKey)}</p>
                <span>{t(descKey)}</span>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </Drawer>
  );
};
